// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","865":"component---src-pages-ai-tsx"}[chunkId] || chunkId) + "-" + {"245":"9d935b7693db101c2009","452":"27c366d60b4b90d0fbfe","454":"ba1846e01b41b7d8adf6","551":"5a8efc1cfdb4fdad6b8e","865":"a422514353c1c19c4e44"}[chunkId] + ".js";
};